const CORNER = /^(?:0|\d{1,4}(?:\.\d{1,3})?(?:px|rem|em|%))$/;
// No quotes, braces, semicolons, backslashes or asterisks: the value cannot leave its declaration or open a comment.
const SHADOW_CSS = /^[a-z0-9#(),.% /+-]{1,300}$/i;
const SHADOW_FUNCTIONS = new Set([
  "rgb",
  "rgba",
  "hsl",
  "hsla",
  "hwb",
  "lab",
  "lch",
  "oklab",
  "oklch",
  "color",
  "color-mix",
  "var",
  "calc",
]);
const SHADOW_TOKENS = new Set(["none", "sm", "md", "lg", "xl", "2xl"]);

export const isCornerLength = (corner: string) => CORNER.test(corner);

/** Up to four corner lengths, as a `border-radius` shorthand takes them. */
export function cornerLengths(value: string): string | undefined {
  const corners = value.trim().split(/\s+/);
  return corners.length <= 4 && corners.every(isCornerLength)
    ? corners.join(" ")
    : undefined;
}

export function safeShadow(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const css = value.trim();
  return SHADOW_CSS.test(css) &&
    [...css.matchAll(/([a-z-]*)\(/gi)].every(([, name]) =>
      SHADOW_FUNCTIONS.has(name.toLowerCase()),
    )
    ? css
    : undefined;
}

/** Own shadow CSS, never a step token or a bare keyword such as the »little« older cards pass for no shadow. */
export function ownShadowCss(value: string): string | undefined {
  return !SHADOW_TOKENS.has(value) && /[\d(]/.test(value)
    ? safeShadow(value)
    : undefined;
}
